import {
  CloseOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import {
  Button,
  Modal,
  Popconfirm,
  Select,
  Space,
  Tag,
  Tooltip,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import { blue, yellowPrimary } from '../../color'
import { ASSIGNEE_TYPE } from '../../constants'
import { AvatarHasName } from '../Common/Avatar'
import { EmptyText } from '../Common/CellText'
import EmptyContent from '../EmptyContent'
import SpinnerInlineComponent from '../SpinnerInlineComponent/SpinnerInlineComponent'
import SelectGroupBox from './SelectGroupBox'

const { Option } = Select

const SelectGroupPopup = props => {
  const {
    id,
    isVisibleSelectGroupPopup,
    handleSubmitSelectGroup,
    handleCancelSelectGroup,
    selectPeopleStore,
    groupType,
    onlySelectOne,
    noLoadSelectData,
    authenticationStore,
    companyStore,
  } = props

  const {
    assigneePopupType,
    selectGroupData,
    setSelectGroupData,
    setGroupList,
    originGroupList,
    companyCode,
  } = selectPeopleStore
  const { companyList } = companyStore

  const [disableGroupList, setDisableGroupList] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [prevSelectedGroupData, setPrevSelectedGroupData] = useState([])

  const handleRemoveSelect = useCallback(
    group => {
      setSelectGroupData({
        ...selectGroupData,
        [assigneePopupType]: selectGroupData[assigneePopupType].filter(
          el => el.id !== group.id
        ),
      })
    },
    [assigneePopupType, selectGroupData]
  )

  useEffect(() => {
    setPrevSelectedGroupData(selectGroupData[assigneePopupType])
  }, [isVisibleSelectGroupPopup])

  useEffect(() => {
    if (!assigneePopupType) return
    const selectedGroupList = [
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]
    setDisableGroupList(
      selectedGroupList
        .filter(el => el.permission !== assigneePopupType)
        .map(el => el.id)
    )
  }, [assigneePopupType])

  useEffect(() => {
    setGroupList(originGroupList)
  }, [isVisibleSelectGroupPopup])

  useEffect(() => {
    if (noLoadSelectData) return
    ;(async () => {
      if (companyCode) {
        if (authenticationStore.currentUser) {
          try {
            setIsLoading(true)
            await selectPeopleStore.getGroupList(
              groupType,
              authenticationStore.currentCompanyCode()
            )
          } catch (err) {
            console.log(err)
            message.error(err.vi || 'Đã có lỗi xảy ra!')
          } finally {
            setIsLoading(false)
          }
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  const onCompanyChange = value => {
    selectPeopleStore.companyCode = value
  }

  return (
    <Modal
      maskClosable={false}
      okText={'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={950}
      footer={null}
      style={{ top: 20 }}
      wrapClassName="custom-modal-wrapper assign-member-modal"
      title={
        <div className="assign-member-modal-title-container">
          <div>
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              className="h-40"
              style={{ width: '100%' }}
              onChange={onCompanyChange}
              value={
                companyCode || authenticationStore?.currentUser?.company?.code
              }
              notFoundContent={<EmptyContent />}
              placeholder={'Chọn công ty'}>
              {companyList?.map(item => (
                <Option key={item.code} value={item.code}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="group-btn-action">
            <Popconfirm
              placement="top"
              zIndex={1600}
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={() =>
                // clearSelectGroup
                //   ? clearSelectGroup()
                //   : handleCancelSelectGroup()

                {
                  selectPeopleStore.handleRemoveSelectGroup()
                }
              }
              okText="Đồng ý"
              cancelText="Không">
              <Button danger className="custom-ant-button">
                Hủy chọn
              </Button>
            </Popconfirm>
            <Button
              type={'primary'}
              onClick={() => {
                JSON.stringify(selectGroupData[assigneePopupType]) !==
                JSON.stringify(prevSelectedGroupData)
                  ? handleSubmitSelectGroup()
                  : handleCancelSelectGroup()
              }}
              className="custom-ant-button">
              Đồng ý
            </Button>
            <CloseOutlined
              onClick={() => {
                setSelectGroupData({
                  ...selectGroupData,
                  [assigneePopupType]: prevSelectedGroupData,
                })
                handleCancelSelectGroup()
              }}
              style={{
                width: 24,
                height: 24,
              }}
            />
          </div>
          <Space></Space>
        </div>
      }
      closable={false}
      forceRender={true}
      visible={isVisibleSelectGroupPopup}>
      <div className="assign-member-modal-left-box">
        <div className="assign-member-modal-left-content">
          <SelectGroupBox
            disableGroupList={disableGroupList}
            onlySelectOne={onlySelectOne}
            isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
          />
          <SpinnerInlineComponent
            sizeSpin={'small'}
            isLoading={isLoading}
            noBackground
          />
        </div>
      </div>
      <div className="assign-member-modal-right-box">
        <div
          style={{
            marginBottom: '16px',
            fontWeight: 500,
          }}>
          Danh sách đã chọn:
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
          }}>
          {assigneePopupType &&
          selectGroupData[assigneePopupType]?.length > 0 ? (
            selectGroupData[assigneePopupType].map(el => {
              return (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      )
                    }
                  />
                </Tag>
              )
            })
          ) : (
            <EmptyText>
              <span style={{ lineHeight: '34px' }}>
                Chưa có nhóm nào được chọn
              </span>
            </EmptyText>
          )}
        </div>
      </div>
    </Modal>
  )
}

SelectGroupPopup.propTypes = {}

export default inject(
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'companyStore'
)(observer(SelectGroupPopup))
